
import { useEffect, useState, useRef, useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import { useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getDistanceFromLatLonInKm } from "../../utils/distance";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import ProviderBookings from "../../components/ProviderBookings";
import GuestBookings from "../../components/GuestBookings";
import { getTranslation } from "../../utils/translations";
import "../../App.css";


export default function HospitalityProvider() {
  const { id } = useParams();
  const { lang } = useContext(LanguageContext);
  const t = getTranslation(lang);
  const chatEndRef = useRef(null);
  const textAreaRef = useRef(null);
  const hasCountedView = useRef(false);

  const [feedback, setFeedback] = useState({});
  const [provider, setProvider] = useState(null);
  const [userCoords, setUserCoords] = useState(null);
  const [distances, setDistances] = useState({});
  const [bookingDate, setBookingDate] = useState({});
  const [dashboard, setDashboard] = useState({});
  const [averageRating, setAverageRating] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [showEmojis, setShowEmojis] = useState(false);
  const [editingMessageId, setEditingMessageId] = useState(null);
  const [editText, setEditText] = useState("");
  const [allGuests, setAllGuests] = useState([]);
  const [selectedGuest, setSelectedGuest] = useState("All");
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [menuModalImage, setMenuModalImage] = useState(null);
  const [showBookingsByBranch, setShowBookingsByBranch] = useState({});
  const [guests, setGuests] = useState(1); // default 1 guest
  const [guestPhone, setGuestPhone] = useState({});
  const [showGuestBookingsByBranch, setShowGuestBookingsByBranch] = useState({});
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const token = localStorage.getItem("token");
  const [refreshBookings, setRefreshBookings] = useState(false);
  const countedBranches = useRef({});

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [notice, setNotice] = useState("");

  const showNotice = (message) => {
    setNotice(message);
    setTimeout(() => setNotice(""), 2500);
  };

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => setLightboxOpen(false);

  const showPrevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => (prev === 0 ? (provider.images.length - 1) : prev - 1));
  };


  const showNextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => (prev === provider.images.length - 1 ? 0 : prev + 1));
  };


  const formatLocalDateTime = (utcString) => {
    if (!utcString) return "";
    const date = new Date(utcString);
    return date.toLocaleString([], {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };


  const fetchDashboard = async (providerObj) => {
    const targetProvider = providerObj || provider;
    if (!targetProvider) return;

    const plan = targetProvider?.membership_plan?.toLowerCase() || "basic";
    if (plan === "basic") return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/tracking/dashboard/${targetProvider.id}`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {}
        }
      );
      if (!res.ok) return;

      const data = await res.json();
      setDashboard(data.branches || {});
    } catch (err) {
      console.error("Failed to fetch dashboard:", err);
    }
  };


  const [isOwner, setIsOwner] = useState(false);

  useEffect(() => {
    if (provider && storedUser) {
      const ownerCheck =
        storedUser.email?.trim().toLowerCase() === provider.owner_email?.trim().toLowerCase();
      setIsOwner(ownerCheck);

      console.log("Stored user:", storedUser);
      console.log("Provider owner_email:", provider.owner_email);
      console.log("Is Owner:", ownerCheck);
    }
  }, [provider, storedUser]);



  const hospitalityEmojis = [
    "☕", "🍵", "🥤", "🍶", "🍷", "🍺", "🍻", "🥂", "🍸", "🥃", "🧋", "🥛", "🍽️", "🍴", "🍕", "🍔", "🍟", "🌮", "🌯", "🥗", "🍝", "🥘", "🍣", "🍱", "🥪",
    "🍲", "🍛", "🥟", "🥩", "🍖", "🥓", "🍤", "🦪", "🍜", "🥣", "🥞", "🧇", "🥯", "🧀", "🥖", "🌶️", "🥫", "🍰", "🍹", "🍧", "🍨", "🍦", "🍼", "🫓", "🫔", "🥠", "🥡", "🥢", "🫙",
    "🌭", "🥙", "🧈", "🎉", "🎊", "🥳", "🎈", "🎂", "🎁", "🪅", "✨", "🌟", "💫", "🪩", "🎵", "🎶", "🎤", "🎧", "🎹", "🥁", "🎷", "🎸", "🎺", "💃", "🕺",
    "🏨", "🛏️", "🛎️", "🧳", "🏩", "🏠", "🏡", "🏕️", "🏖️", "🏛️", "🌆", "🏙️", "🏰", "🗝️", "🏟️", "🎡", "🎢", "🎠", "🛶", "🛳️", "✈️", "🚂", "🚢", "🚤", "🏯", "🗼", "🗽",
    "😍", "😋", "😄", "😁", "😂", "🤣", "🥰", "😎", "🤩", "🤪", "😜", "😝", "😛", "😏", "🥵", "🥶", "🤯", "🤗", "🤔", "🤤", "😇", "😈", "👻", "💀", "👽", "🤡", "👾", "🤖", "🫠", "🥴",
    "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💖", "💗", "💓", "💞", "💝", "💘", "💌", "🔥", "⭐", "✨", "👍", "👏", "🫂", "🧑‍🍳", "🧑‍🎤", "🧑‍🎓", "🕯️", "🎆",
    "🎇", "🎭", "🎟️", "📸", "💥", "💨", "🌪️", "🌊", "☀️", "🌤️", "🌥️", "☁️", "🌦️", "🌧️", "⛈️", "🌩️", "🌨️", "❄️", "🍀", "🌹", "🌺", "🌻", "🌼", "🌷", "💐", "🌵", "🎃", "🎄",
    "🎋", "🎍", "🪴", "🪹", "🪵", "🛒", "🧺"
  ];

  const handleGuestLogin = async () => {
    setLoginError("");
    if (!loginEmail || !loginPassword) {
      setLoginError("Please enter email and password");
      return;
    }
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: loginEmail, password: loginPassword })
      });

      if (!res.ok) {
        const errorData = await res.json();
        return setLoginError(errorData.message || "Login failed");
      }

      const data = await res.json();
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("token", data.token);
      window.location.reload();
    } catch (err) {
      console.error(err);
      setLoginError("Login failed. Please try again.");
    }
  };

  const addEmojiToInput = (emoji) => {
    setNewMessage(prev => prev + emoji);
    textAreaRef.current?.focus();
  };


  const sendTrackingEvent = async (providerId, branchId, type) => {
    if (!providerId || !branchId) return;
    if (provider?.membership_plan?.toLowerCase() === "basic") return;

    try {
      await fetch(`${process.env.REACT_APP_API_URL}/api/tracking/${type}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ providerId, branchId })
      });
      await fetchDashboard();
    } catch (err) {
      console.error("Tracking error:", err);
    }
  };


  // Handles contact clicks safely (tracks event before navigating)
  const handleContactClick = async (branchName, url, type = "contact", newTab = false) => {
    try {
      const branch = provider?.branches?.find(b => b.branch_name === branchName);
      if (branch) {
        await sendTrackingEvent(provider.id, branch.id, type);
      }
    } catch (err) {
      console.error("Tracking failed:", err);
    }

    if (newTab) {
      window.open(url, "_blank");
    } else {
      window.location.href = url;
    }
  };

  // ---------------- FETCH PROVIDER -----------------
  useEffect(() => {
    async function fetchProvider() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/providers/${id}?lang=${lang}`
        );
        const data = await res.json();
        if (!data) return;

        setProvider(data);
        await fetchDashboard(data);

      } catch (err) {
        console.error(err);
      }
    }

    fetchProvider();
  }, [id, lang]);


  // ---------------- TRACK VIEWS (ONCE) -----------------
  useEffect(() => {
    if (!provider || hasCountedView.current) return;
    if (provider?.membership_plan?.toLowerCase() === "basic") return;

    hasCountedView.current = true;

    for (const branch of provider.branches || []) {
      const branchKey = branch.branch_name
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-");

      if (!countedBranches.current[branchKey]) {
        sendTrackingEvent(provider.id, branch.id, "view");
        countedBranches.current[branchKey] = true;
      }
    }
  }, [provider]);


  useEffect(() => {
    if (provider && token) {
      fetchDashboard(); // ensures latest data is always fetched when provider loads
    }
  }, [provider, token]);


  useEffect(() => {
    if (!navigator.geolocation) {
      console.warn("Geolocation not supported by this browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setUserCoords({ lat: pos.coords.latitude, lng: pos.coords.longitude });
      },
      (err) => {
        console.warn("Geolocation failed:", err.code, err.message);
        // err.code:
        // 1 = PERMISSION_DENIED
        // 2 = POSITION_UNAVAILABLE
        // 3 = TIMEOUT
        setUserCoords(null);
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  }, []);

  // ---------------- AVERAGE RATING -----------------
  useEffect(() => {
    async function fetchAverageRating() {
      if (!provider) return;
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/comments`);
        const data = await res.json();
        const providerKey = provider.id;
        const providerData = data[providerKey];
        if (providerData?.average_rating !== undefined) setAverageRating(providerData.average_rating.toFixed(1));
        else setAverageRating("0");
      } catch (err) {
        console.error("Failed to fetch average rating:", err);
        setAverageRating("0");
      }
    }
    fetchAverageRating();
  }, [provider]);

  // ---------------- CHAT -----------------
  useEffect(() => {
    if (!provider || !token) return;
    if (provider?.membership_plan?.toLowerCase() !== "premium") return;

    const fetchMessages = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/messages/${provider.id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const msgs = await res.json();
        setMessages(Array.isArray(msgs) ? msgs.map(m => ({ ...m, isRead: m.isRead ?? false })) : []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchMessages();
    const interval = setInterval(fetchMessages, 3000);
    return () => clearInterval(interval);
  }, [provider, token]);


  useEffect(() => {
    if (!isOwner || !provider || !messages.length) return;

    // Get unique guests who sent messages
    const uniqueGuests = {};

    messages.forEach(msg => {
      if (msg.sender !== "owner" && msg.user_email) {
        uniqueGuests[msg.user_email] = {
          email: msg.user_email,
          name: msg.sender_name || msg.user_email
        };
      }
    });

    const guestArray = Object.values(uniqueGuests);

    setAllGuests(guestArray);

    // Auto select first guest if none selected
    if (guestArray.length > 0 && !selectedGuest) {
      setSelectedGuest(guestArray[0].email);
    }
  }, [messages, isOwner, provider]);


  // ---------------- BRANCHES -----------------
  const branches = Array.isArray(provider?.branches) && provider.branches.length
    ? provider.branches
    : [{
      id: provider?.id,
      branch_name: provider?.name || "main",
      address: provider?.address,
      phone: provider?.phone,
      whatsapp: provider?.whatsapp,
      telegram: provider?.telegram,
      services: provider?.services,
      lat: provider?.lat,
      lng: provider?.lng,
      monday_open: provider?.monday_open,
      monday_close: provider?.monday_close,
      tuesday_open: provider?.tuesday_open,
      tuesday_close: provider?.tuesday_close,
      wednesday_open: provider?.wednesday_open,
      wednesday_close: provider?.wednesday_close,
      thursday_open: provider?.thursday_open,
      thursday_close: provider?.thursday_close,
      friday_open: provider?.friday_open,
      friday_close: provider?.friday_close,
      saturday_open: provider?.saturday_open,
      saturday_close: provider?.saturday_close,
      sunday_open: provider?.sunday_open,
      sunday_close: provider?.sunday_close
    }];

  const membershipPlan = provider?.membership_plan?.toLowerCase() || "basic";
  const isBasicPlan = membershipPlan === "basic";
  const isPremiumPlan = membershipPlan === "premium";

  const canShowReservations = !isBasicPlan;   // pro + premium
  const canShowDashboard = !isBasicPlan;      // pro + premium
  const canShowChatbox = isPremiumPlan;       // premium only


  useEffect(() => {
    const dist = {};
    branches.forEach(b => {
      if (userCoords && b.lat && b.lng)
        dist[b.branch_name] = getDistanceFromLatLonInKm(userCoords.lat, userCoords.lng, b.lat, b.lng).toFixed(1);
      else dist[b.branch_name] = null;
    });
    setDistances(dist);
  }, [provider, userCoords]);

  const displayedMessages = isOwner
    ? messages.filter(
      m =>
        m.user_email === selectedGuest ||
        m.target_email === selectedGuest
    )
    : messages.filter(
      m =>
        m.user_email === storedUser?.email ||
        m.target_email === storedUser?.email
    );


  const toggleBranchStatus = async (branchId) => {
    if (!isOwner) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/branches/${branchId}/toggle-status`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );

      const data = await res.json();

      if (!res.ok) {
        return showNotice(data.message || "Failed to update branch status");
      }

      // update branch locally
      setProvider(prev => ({
        ...prev,
        branches: prev.branches.map(b =>
          b.id === branchId
            ? {
              ...b,
              forced_closed: data.branch.forced_closed,
              now_status: data.branch.forced_closed ? "Closed" : "Open"
            }
            : b
        )
      }));

    } catch (err) {
      console.error(err);
    }
  };


  // ---------------- HANDLERS -----------------
  const handleReservation = async (branch) => {
    if (provider?.membership_plan?.toLowerCase() === "basic") {
      return showNotice("Reservations are not available for this provider plan.");
    }

    if (!storedUser) return showNotice(t.provider_page.login_to_reserve);
    if (!bookingDate[branch.branch_name]) return showNotice("Select date & time");

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/reservations`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          provider_id: provider.id,
          branch_id: branch.id,
          dateTime: bookingDate[branch.branch_name].toISOString(),
          guests: guests,
          phone: guestPhone[branch.branch_name] || ""
        })
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) return showNotice(data.message || t.provider_page.reservation_failed);

      showNotice(t.provider_page.reservation_confirmed_success);

      await sendTrackingEvent(provider.id, branch.id, "reservation");

      await fetchDashboard();
      setRefreshBookings(prev => !prev);
    } catch (err) {
      console.error(err);
      showNotice(t.provider_page.reservation_failed);
    }
  };


  const handleCancelBooking = async (id) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/reservations/${id}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }
      });

      let data = {};
      try { data = await res.json(); } catch { data = {}; }

      if (!res.ok) return showNotice(data.message || "Failed to cancel booking ❌");

      showNotice(data.message || "Booking cancelled ✅");
      await fetchDashboard(); // optional: refresh dashboard
    } catch (err) {
      console.error(err);
      showNotice("Failed to cancel booking ❌");
    }
  };


  const handleSendMessage = async () => {
    if (!newMessage.trim() || !storedUser) return;

    let targetGuest = selectedGuest;

    if (isOwner) {
      if (!targetGuest) {
        return showNotice("Please select a guest to message");
      }
    }

    const body = { provider_id: provider.id, message: newMessage.trim() };
    if (isOwner) body.target_email = targetGuest;

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/messages`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        const error = await res.json();
        return showNotice(error.message || "Failed to send message");
      }

      const saved = await res.json();
      setMessages(prev => [...prev, { ...saved, isRead: true }]);
      setNewMessage("");
      chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    } catch (err) { console.error(err); }
  };

  const handleEditMessage = async (msg) => {
    if (!editText.trim()) return showNotice("Message cannot be empty");

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/messages/${msg.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ newMessage: editText }),
      });
      if (!res.ok) throw new Error("Failed to update message");
      const updated = await res.json();
      setMessages(prev => prev.map(m => m.id === msg.id ? { ...updated, isRead: m.isRead } : m));
      setEditingMessageId(null);
      setEditText("");
    } catch (err) {
      console.error(err);
      showNotice("Failed to save message edit");
    }
  };

  const handleDeleteMessage = async (msg) => {
    if (!window.confirm(t.provider_page.delete_message_confirm)) return;

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/messages/${msg.id}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error("Failed to delete message");
      setMessages(prev => prev.map(m => m.id === msg.id ? { ...m, deleted: true, message: "This message has been deleted" } : m));
    } catch (err) { console.error(err); }
  };

  // ---------------- RENDER -----------------
  return (
    <div className="provider-page">
      {notice && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#ffffff",
            color: "#111",
            padding: "12px 16px",
            borderRadius: "10px",
            border: "1px solid #e5e7eb",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            zIndex: 9999,
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          {notice}
        </div>
      )}

      {/* Provider Header */}
      <div className="provider-header" style={{ textAlign: "center", marginBottom: 30 }}>
        <h1 style={{ fontSize: "2rem" }}>
          {provider?.name}{" "}
          {provider?.paid_plan && provider?.verified && (
            <span style={{ color: "#fff", fontSize: "25px", backgroundColor: "#228B22" }}>✅ Verified</span>
          )}
        </h1>

        {averageRating && <h2 style={{ marginTop: 8 }}>⭐ {t.provider_page.average_rating}: {averageRating}</h2>}

        {provider?.whyChoose && (
          <div className="why-choose" style={{ marginTop: 10 }}>
            <h3>🏆 {t.provider_page.why_choose}</h3>
            <p>{provider.whyChoose}</p>
          </div>
        )}
      </div>

      {/* Branches */}
      {branches.map((b) => {
        console.log("Dashboard object:", dashboard);
        console.log("Current branch id:", b.id);
        console.log("Current branch name:", b.branch_name);
        const dist = distances[b.branch_name] || null;
        const menuImage = provider?.menus?.[b.id] || null;

        return (
          <div key={b.branch_name} className="branch-container" style={{ display: "flex", gap: 20, alignItems: "flex-start" }}>
            {/* Dashboard */}
            {canShowDashboard && (
              <div className="branch-dashboard"
                style={{
                  flex: "0 0 250px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  background: "#0f172a",
                  minWidth: 250,
                  borderRadius: 16,
                  padding: "10px",
                  marginBottom: 0,
                  transition: "transform 0.3s, box-shadow 0.3s",
                  cursor: "pointer",
                  alignSelf: "stretch",
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.2)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
                }}
              >
                <h3 style={{ color: "#ffffff", fontWeight: "bold", marginBottom: 16 }}>
                  📊 {t.provider_page.branch_dashboard}
                </h3>

                <div className="dashboard-metrics" style={{ display: "flex", gap: 20 }}>
                  <div className="metric" style={{ flex: 1 }}>
                    <CircularProgressbar
                      value={dashboard[b.id]?.visits || 0}
                      maxValue={1000}
                      text={`${dashboard[b.id]?.visits || 0}`}
                      styles={buildStyles({ textColor: "#ffffff", pathColor: "#2563eb" })}
                    />
                    <p style={{ color: "#f97316", fontWeight: "bold", marginTop: 10 }}>
                      {t.provider_page.profile_views}
                    </p>
                  </div>

                  <div className="metric" style={{ flex: 1 }}>
                    <CircularProgressbar
                      value={dashboard[b.id]?.reservations || 0}
                      maxValue={1000}
                      text={`${dashboard[b.id]?.reservations || 0}`}
                      styles={buildStyles({ textColor: "#ffffff", pathColor: "#10b981" })}
                    />
                    <p style={{ color: "#f97316", fontWeight: "bold", marginTop: 10 }}>
                      {t.provider_page.reservation_requests}
                    </p>
                  </div>

                  <div className="metric" style={{ flex: 1 }}>
                    <CircularProgressbar
                      value={dashboard[b.id]?.contacts || 0}
                      maxValue={1000}
                      text={`${dashboard[b.id]?.contacts || 0}`}
                      styles={buildStyles({ textColor: "#ffffff", pathColor: "#ef4444" })}
                    />
                    <p style={{ color: "#f97316", fontWeight: "bold", marginTop: 10 }}>
                      {t.provider_page.contact_clicks}
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Branch Details + Menu */}
            <div className="branch-with-menu" style={{ display: "flex", flex: 1, gap: 20, marginTop: 20 }}>
              {/* Branch Details */}
              <div
                className="branch-details"
                style={{
                  flex: 2,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  padding: 20,
                  background: "#1f2937",
                  color: "#e5e7eb",
                  borderRadius: 12,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                  minHeight: "550px"
                }}
              >
                <div style={{ flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                  <h2 style={{ color: "#3b82f6", fontWeight: "bold", fontSize: "1.9rem", marginBottom: 15, textAlign: "center" }}>
                    {b.branch_name}
                  </h2>
                  <p style={{ color: "#e5e7eb" }}>📍 <strong>{t.provider_page.distance}:</strong> {dist} km</p>
                  <p style={{ color: "#e5e7eb" }}><strong>🏠 {t.provider_page.address}:</strong> {b.address}</p>
                  <p style={{ color: "#e5e7eb" }}><strong>🍽️ {t.provider_page.services}:</strong> {b.services}</p>



                  <p style={{ color: "#e5e7eb" }}>
                    <strong>📞 {t.provider_page.phone}:</strong>{" "}
                    <a
                      href={`tel:${b.phone}`}
                      style={{ color: "#60a5fa", textDecoration: "underline" }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleContactClick(b.branch_name, `tel:${b.phone}`);
                      }}
                    >
                      {b.phone}
                    </a>
                  </p>

                  <p style={{ color: "#e5e7eb" }}>
                    <strong>📱 WhatsApp:</strong>{" "}
                    <a
                      href={`https://wa.me/${b.whatsapp}`}
                      style={{ color: "#34d399", textDecoration: "underline" }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleContactClick(b.branch_name, `https://wa.me/${b.whatsapp}`, "contact", true);
                      }}
                    >
                      {b.whatsapp}
                    </a>
                  </p>

                  <p style={{ color: "#e5e7eb" }}>
                    <strong>💬 Telegram:</strong>{" "}
                    <a
                      href={`https://t.me/${b.telegram}`}
                      style={{ color: "#a78bfa", textDecoration: "underline" }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleContactClick(b.branch_name, `https://t.me/${b.telegram}`, "contact", true);
                      }}
                    >
                      {b.telegram}
                    </a>
                  </p>


                  <p style={{ color: "#facc15" }}><strong>⏰ {t.provider_page.operating_hours}:</strong></p>
                  <p style={{ color: "#e5e7eb" }}>
                    <strong>{t.provider_page.mon_fri}:</strong> {b.monday_open} - {b.friday_close}
                  </p>

                  <p style={{ color: "#e5e7eb" }}>
                    <strong>{t.provider_page.sat}:</strong> {b.saturday_open} - {b.saturday_close}
                  </p>

                  <p style={{ color: "#e5e7eb" }}>
                    <strong>{t.provider_page.sun}:</strong> {b.sunday_open} - {b.sunday_close}
                  </p>

                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>

                    <p style={{ color: "#e5e7eb" }}>
                      🗺️{" "}
                      <a
                        href={`https://www.google.com/maps/search/?api=1&query=${b.lat},${b.lng}`}
                        target="_blank"
                        style={{ color: "#f87171", fontWeight: "bold", textDecoration: "underline" }}
                      >
                        {t.provider_page.get_directions}
                      </a>
                    </p>

                    <button
                      onClick={() => toggleBranchStatus(b.id)}
                      disabled={!isOwner}
                      style={{
                        padding: "6px 12px",
                        borderRadius: "8px",
                        border: "1px solid #6b7280",
                        fontWeight: "bold",
                        cursor: isOwner ? "pointer" : "default",
                        background: "#4b5563",
                        color: "#fff",
                        opacity: isOwner ? 1 : 0.85,
                        transition: "all 0.2s ease"
                      }}
                    >
                      {b.now_status === "Open" ? "🟢" : "🔴"} {t.provider_page.now_label}: {b.now_status === "Open" ? t.provider_page.open : t.provider_page.closed}
                      {b.next_time && (
                        <span style={{ marginLeft: 6, fontSize: "0.85rem", fontWeight: "bold" }}>
                          <span style={{ color: "#ffffff" }}>• </span>

                          <span style={{ color: b.next_label === "closes" ? "#ef4444" : "#22c55e" }}>
                            {b.next_label === "closes" ? t.provider_page.closes_at : t.provider_page.opens_at}
                          </span>{" "}

                          <span style={{ color: "#ffffff" }}>
                            {b.next_time.slice(0, 5)}
                          </span>
                        </span>
                      )}
                    </button>

                  </div>

                  {canShowReservations && (
                    <DatePicker
                      selected={bookingDate[b.branch_name]}
                      onChange={(d) => setBookingDate(prev => ({ ...prev, [b.branch_name]: d }))}
                      showTimeSelect
                      dateFormat="Pp"
                      minDate={new Date()}
                      placeholderText={t.provider_page.select_date_time}
                      style={{ marginTop: 10 }}
                    />
                  )}
                  {canShowReservations && (
                    <input
                      type="tel"
                      placeholder={t.provider_page.optional_phone}
                      value={guestPhone[b.branch_name] || ""}
                      onChange={e => setGuestPhone(prev => ({ ...prev, [b.branch_name]: e.target.value }))}
                      style={{
                        marginTop: 10,
                        padding: 6,
                        borderRadius: 5,
                        width: "100%"
                      }}
                    />
                  )}

                  {/*
                  {bookingDate[b.branch_name] && (
                    <p style={{ color: "#34d399", marginTop: 8, fontWeight: "bold" }}>
                     🗓️ Selected date & time: {formatLocalDateTime(bookingDate[b.branch_name].toISOString())}
                    </p>
                  )}
                  */}

                  {canShowReservations && (
                    <div style={{ marginTop: 10 }}>
                      <label htmlFor={`guests-${b.branch_name}`} style={{ color: "#e5e7eb", fontWeight: "bold", marginRight: 8 }}>
                        👥 {t.provider_page.guests}:
                      </label>
                      <input
                        id={`guests-${b.branch_name}`}
                        type="number"
                        min="1"
                        max="20"
                        value={guests}
                        onChange={(e) => setGuests(Number(e.target.value))}
                        style={{ padding: 6, width: 60, borderRadius: 6 }}
                      />
                    </div>
                  )}
                </div>


                {/* Reserve + Bookings Button */}
                {canShowReservations && (
                  <div style={{ display: "flex", justifyContent: "center", gap: 10, marginTop: 20 }}>
                    <button
                      onClick={() => handleReservation(b)}
                      style={{
                        padding: "10px 20px",
                        background: "#22c55e",
                        color: "#fff",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontWeight: "bold"
                      }}
                    >
                      {t.provider_page.reserve}
                    </button>

                    {isOwner && (
                      <button
                        onClick={() => setShowBookingsByBranch(prev => ({
                          ...prev,
                          [b.branch_name]: !prev[b.branch_name]
                        }))}
                        style={{
                          padding: "10px 20px",
                          background: "#2563eb",
                          color: "#fff",
                          borderRadius: 8,
                          cursor: "pointer",
                          fontWeight: "bold"
                        }}
                      >
                        {showBookingsByBranch[b.branch_name]
                          ? t.provider_page.hide_reservations
                          : t.provider_page.view_reservations}
                      </button>
                    )}

                    {!isOwner && storedUser && (
                      <button
                        onClick={() => setShowGuestBookingsByBranch(prev => ({
                          ...prev,
                          [b.branch_name]: !prev[b.branch_name]
                        }))}
                        style={{
                          padding: "10px 20px",
                          background: "#2563eb",
                          color: "#fff",
                          borderRadius: 8,
                          cursor: "pointer",
                          fontWeight: "bold"
                        }}
                      >
                        {showGuestBookingsByBranch[b.branch_name]
                          ? t.provider_page.hide_reservations
                          : t.provider_page.view_reservations}
                      </button>
                    )}
                  </div>
                )}

                {/* GuestBookings rendered only if toggled */}
                {canShowReservations && storedUser && showGuestBookingsByBranch[b.branch_name] && (
                  <div style={{ marginTop: 40 }}>
                    <GuestBookings
                      token={token}
                      providerId={provider.id}
                      branchId={b.id}
                      refresh={refreshBookings}
                    />
                  </div>
                )}

                {/* Show Bookings */}
                {canShowReservations && isOwner && provider && showBookingsByBranch[b.branch_name] && (
                  <div style={{ marginTop: 12, background: "#1f2937", borderRadius: 12, padding: 12 }}>
                    <ProviderBookings
                      providerId={provider.id}
                      branchId={b.id}
                      token={token}
                      onCancelBooking={handleCancelBooking}
                      refreshTrigger={refreshBookings}
                    />
                  </div>
                )}
              </div>

              {/* Menu Card */}
              <div
                className="menu-card"
                style={{
                  flex: 1,
                  borderRadius: "12px",
                  overflow: "hidden",
                  background: "#1f2937",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  transition: "transform 0.3s, box-shadow 0.3s",
                  cursor: "pointer",
                  position: "sticky",
                  top: "20px"
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.2)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
                }}
              >
                <img
                  src={menuImage ? `${process.env.REACT_APP_API_URL}${menuImage}` : "/placeholder-menu.jpg"}
                  alt={`${b.branch_name} menu`}
                  style={{
                    width: "100%",
                    height: "250px",
                    objectFit: "cover",
                    transition: "transform 0.3s",
                    cursor: "pointer"
                  }}
                  onMouseEnter={e => e.currentTarget.style.transform = "scale(1.1)"}
                  onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                />
                <div style={{ padding: "12px" }}>
                  <h3 style={{ marginBottom: 8, fontSize: "1.3rem", fontWeight: "bold", color: "#ef4444" }}>📋 {t.provider_page.menu}</h3>
                  <p style={{ fontSize: "1.1rem", color: "#ffffff" }}>
                    {t.provider_page.explore_menu}
                  </p>

                  <button
                    onClick={() =>
                      setMenuModalImage(
                        menuImage?.startsWith("http")
                          ? menuImage
                          : `${process.env.REACT_APP_API_URL}${menuImage}`
                      )
                    }
                    style={{
                      fontWeight: "bold",
                      color: "#22c55e",
                      fontSize: "1.3rem",
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      textDecoration: "underline"
                    }}
                  >
                    {t.provider_page.view_full_menu}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      {/* ---------------- Guest Chat ---------------- */}
      {canShowChatbox && (
        <div style={{ marginTop: 30, marginBottom: 30, background: "#111827", padding: 20, borderRadius: 16, color: "#e5e7eb" }}>
          <h3 style={{ color: "#3b82f6", fontWeight: "bold", marginBottom: 15 }}>💬 {t.provider_page.guest_chat}</h3>

          {!storedUser && (
            <form
              onSubmit={(e) => {
                e.preventDefault();  // prevent page reload
                handleGuestLogin();  // call your login function
              }}
              style={{ marginTop: 10 }}
            >
              <p style={{ color: "#ffffff" }}>
                {t.provider_page.please}{" "}
                <span style={{ color: "#ef4444" }}>
                  {t.provider_page.log_in}
                </span>{" "}
                {t.provider_page.to_start_chatting}
              </p>
              {loginError && <p style={{ color: "red" }}>{loginError}</p>}
              <input
                type="email"
                placeholder={t.provider_page.email_placeholder}
                value={loginEmail}
                onChange={e => setLoginEmail(e.target.value)}
                style={{ width: 200, marginRight: 5, padding: 6, borderRadius: 5 }}
              />
              <input
                type="password"
                placeholder={t.provider_page.password_placeholder}
                value={loginPassword}
                onChange={e => setLoginPassword(e.target.value)}
                style={{ width: 200, marginRight: 5, padding: 6, borderRadius: 5 }}
              />
              <button
                onClick={handleGuestLogin}
                style={{ padding: "6px 12px", borderRadius: 5, background: "#0284c7", color: "#fff" }}
              >
                {t.provider_page.login_button}
              </button>
            </form>
          )}

          <div style={{ width: "100%" }}>
            {/* OWNER Guest Filter */}
            {isOwner && (
              <div
                style={{
                  marginBottom: 15,
                  padding: 12,
                  background: "#0f172a",
                  borderRadius: 12,
                  border: "1px solid #334155"
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <strong style={{ color: "#3b82f6" }}>
                    👥 {t.provider_page.guest_filter} ({allGuests.length})
                  </strong>

                  {selectedGuest && (
                    <span style={{ color: "#22c55e", fontSize: "0.9rem" }}>
                      {t.provider_page.chatting_with}:{" "}
                      {allGuests.find(g => g.email === selectedGuest)?.name || ""}
                    </span>
                  )}
                </div>

                <select
                  value={selectedGuest || ""}
                  onChange={(e) => setSelectedGuest(e.target.value)}
                  style={{
                    marginTop: 10,
                    padding: 8,
                    borderRadius: 8,
                    width: "100%",
                    background: "#1f2937",
                    color: "#fff",
                    border: "1px solid #475569"
                  }}
                >
                  <option value="">-- {t.provider_page.select_guest_placeholder} --</option>
                  {allGuests.map((guest) => (
                    <option key={guest.email} value={guest.email}>
                      {guest.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Messages Container */}
            <div style={{ width: "100%", minHeight: 250, overflow: "auto", color: "#e5e7eb", border: "1px solid #374151", borderRadius: 16, padding: 10, background: "#1f2937", resize: "both" }}>
              {displayedMessages.length === 0 ? (
                !storedUser ? (
                  <p style={{ color: "#9ca3af", fontWeight: "bold" }}>
                    {t.provider_page.login_to_see_messages}
                  </p>
                ) : isOwner ? (
                  <p style={{ color: "#9ca3af", fontWeight: "bold" }}>
                    {t.provider_page.message_guest_hint} 😊
                  </p>
                ) : (
                  <p style={{ color: "#9ca3af", fontWeight: "bold" }}>
                    {t.provider_page.no_messages_yet} 😊
                  </p>
                )
              ) : (
                // If there are messages, show the "Log in to see your messages" for guests (if needed)
                displayedMessages.length > 0 && !storedUser && (
                  <p style={{ color: "#9ca3af", fontWeight: "bold" }}>
                    {t.provider_page.login_to_see_messages}
                  </p>
                )
              )}

              {displayedMessages.map((m, i) => {
                const isSent = m.user_email === storedUser?.email;
                const alignStyle = { display: "flex", justifyContent: isSent ? "flex-end" : "flex-start", marginBottom: 10 };
                const bubbleStyle = {
                  maxWidth: "80%",
                  background: "#1f2937",
                  border: isSent ? "3px solid #2563eb" : "3px solid #facc15",
                  borderRadius: 12,
                  padding: 8,
                  overflowWrap: "break-word",
                  wordBreak: "break-word"
                };

                return (
                  <div key={i} style={alignStyle}>
                    <div style={bubbleStyle}>
                      <div style={{ fontSize: 16, marginBottom: 6, color: "#22c55e", fontWeight: "bold" }}>
                        {m.sender_name}
                      </div>

                      {/* Deleted message */}
                      {m.deleted ? (
                        <p style={{ fontStyle: "italic", color: "#9ca3af", margin: "2px 0", fontSize: 15, textAlign: "center" }}>
                          {t.provider_page.message_deleted}
                        </p>
                      ) : editingMessageId === m.id ? (
                        // Edit mode
                        <div style={{ marginTop: 4 }}>
                          <textarea
                            value={editText}
                            onChange={e => setEditText(e.target.value)}
                            rows={2}
                            style={{ width: "100%", borderRadius: 8, background: "#374151", color: "#e5e7eb", border: "1px solid #4b5563" }}
                          />
                          <div style={{ marginTop: 4 }}>
                            <button onClick={() => handleEditMessage(m)}>Save</button>
                            <button onClick={() => setEditingMessageId(null)}>Cancel</button>
                          </div>
                        </div>
                      ) : (
                        // Normal or edited message
                        <p style={{ margin: "2px 0", fontSize: 15, color: "#e5e7eb", fontFamily: "Arial, sans-serif" }}>
                          {m.message} {m.edited ? `(${t.provider_page.edited})` : ""}
                        </p>
                      )}

                      {/* Edit / Delete buttons (only if not deleted) */}
                      {!m.deleted && isSent && editingMessageId !== m.id && (
                        <div style={{ marginTop: 4, textAlign: "right" }}>
                          <span
                            onClick={() => { setEditingMessageId(m.id); setEditText(m.message); }}
                            style={{ color: "#facc15", fontWeight: "bold", cursor: "pointer", fontStyle: "italic", fontSize: "0.85rem", marginRight: 6 }}
                          >
                            {t.provider_page.edit}
                          </span>
                          <span
                            onClick={() => handleDeleteMessage(m)}
                            style={{ color: "#f87171", fontWeight: "bold", cursor: "pointer", fontStyle: "italic", fontSize: "0.85rem" }}
                          >
                            {t.provider_page.delete}
                          </span>
                        </div>
                      )}

                      {/* Timestamp always visible */}
                      <div style={{ fontSize: 10, color: "#9ca3af", fontWeight: "bold", marginTop: 4 }}>
                        {new Date(m.timestamp).toLocaleString([], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })}
                      </div>
                    </div>
                  </div>
                );
              })}

              <div ref={chatEndRef}></div>
            </div>

            {/* Input + Buttons */}
            <div style={{ display: "flex", marginTop: 10, gap: 5, alignItems: "center" }}>
              <button onClick={() => setShowEmojis(prev => !prev)} style={{ padding: 8, borderRadius: 8 }}>😊</button>
              <textarea
                ref={textAreaRef}
                value={newMessage}
                onChange={e => setNewMessage(e.target.value)}
                placeholder={t.provider_page.type_message_placeholder}
                style={{ flex: "1 1 auto", padding: 12, borderRadius: 16, resize: "both", background: "#374151", color: "#e5e7eb", overflow: "auto" }}
                onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSendMessage(); } }}
              />
              <button
                onClick={handleSendMessage}
                style={{ background: "#0284c7", color: "#fff", border: "none", borderRadius: 16, padding: "12px 16px", cursor: "pointer" }}
              >
                {t.provider_page.send}
              </button>
            </div>

            {/* Emoji Picker */}
            {showEmojis && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 5, maxWidth: 500 }}>
                {hospitalityEmojis.map((e, i) => (
                  <span key={i} style={{ cursor: "pointer", fontSize: "1.4rem" }} onClick={() => addEmojiToInput(e)}>{e}</span>
                ))}
              </div>
            )}
          </div>

        </div>
      )}

      {/* ---------------- Provider Media (Images + Videos) ---------------- */}
      <div className="provider-media" style={{ display: "flex", flexWrap: "wrap", gap: 12, marginTop: 20 }}>
        {(provider?.images || []).map((media, i) => {
          const isVideo = media.endsWith(".mp4"); // detect video

          return (
            <div
              key={i}
              style={{
                width: "250px",
                height: "190px",
                borderRadius: "12px",
                overflow: "hidden",
                cursor: isVideo ? "default" : "pointer",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                position: "relative",
              }}
              onClick={() => !isVideo && openLightbox(i)}
            >
              {isVideo ? (
                <video
                  src={media.startsWith("http") ? media : `${process.env.REACT_APP_API_URL}${media}`}
                  controls
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <img
                  src={media.startsWith("http") ? media : `${process.env.REACT_APP_API_URL}${media}`}
                  alt={`${provider.name} media ${i + 1}`}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              )}
            </div>
          );
        })}
      </div>

      {lightboxOpen && (
        <div
          onClick={closeLightbox}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.95)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            cursor: "pointer",
            overflow: "hidden",
          }}
        >
          {/* Close button */}
          <button
            onClick={closeLightbox}
            style={{
              position: "absolute",
              top: 20,
              right: 20,
              fontSize: "2rem",
              background: "transparent",
              border: "none",
              color: "#fff",
              cursor: "pointer",
              zIndex: 1010,
            }}
          >
            ✖
          </button>

          {/* Previous arrow */}
          <button
            onClick={showPrevImage}
            style={{
              position: "absolute",
              left: 20,
              fontSize: "2rem",
              background: "transparent",
              border: "none",
              color: "#fff",
              cursor: "pointer",
              zIndex: 1010,
            }}
          >
            ◀
          </button>

          {/* Media display (image or video) */}
          {provider.images[currentImageIndex].endsWith(".mp4") ? (
            <video
              src={
                provider.images[currentImageIndex].startsWith("http")
                  ? provider.images[currentImageIndex]
                  : `${process.env.REACT_APP_API_URL}${provider.images[currentImageIndex]}`
              }
              controls
              autoPlay
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                objectFit: "contain",
                cursor: "default",
              }}
              onClick={(e) => e.stopPropagation()}
            />
          ) : (
            <img
              src={provider.images[currentImageIndex].startsWith("http")
                ? provider.images[currentImageIndex]
                : `${process.env.REACT_APP_API_URL}${provider.images[currentImageIndex]}`
              }
              alt="Fullscreen"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                objectFit: "contain",
                cursor: "pointer"
              }}
              onClick={e => e.stopPropagation()}
            />
          )}
          {/* Next arrow */}
          <button
            onClick={showNextImage}
            style={{
              position: "absolute",
              right: 20,
              fontSize: "2rem",
              background: "transparent",
              border: "none",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            ▶
          </button>
        </div>
      )}

      {menuModalImage && (
        <div
          onClick={() => setMenuModalImage(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(15, 23, 42, 0.95)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            cursor: "pointer",
            overflow: "hidden",
          }}
        >

          {/* Close button */}
          <button
            onClick={() => setMenuModalImage(null)}
            style={{
              position: "absolute",
              top: 20,
              right: 20,
              fontSize: "2.5rem",
              background: "transparent",
              border: "none",
              color: "#fff",
              cursor: "pointer",
              zIndex: 1010,
            }}
          >
            ✖
          </button>

          {/* Full screen menu image */}
          <img
            src={menuModalImage}
            alt="Full Menu"
            style={{
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              objectFit: "contain",
              cursor: "default",
            }}
            onClick={e => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
